var _defs, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAllAffiliate(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 100 100",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .st0 {\n        fill: #fff;\n      }\n    "))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M48.8,3.29c-4.24,0-7.69,3.46-7.69,7.7s3.45,7.69,7.69,7.69,7.7-3.45,7.7-7.69-3.46-7.7-7.7-7.7ZM48.8,14.55c-1.96,0-3.56-1.6-3.56-3.56s1.6-3.57,3.56-3.57,3.57,1.6,3.57,3.57-1.6,3.56-3.57,3.56Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M48.8,20.18c-7.34,0-13.31,6.06-13.31,13.5v2.07h26.63v-2.07c0-7.44-5.97-13.5-13.32-13.5ZM39.79,31.62l.35-1c1.3-3.72,4.86-6.32,8.66-6.32s7.35,2.54,8.67,6.32l.35,1h-18.03Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M82.57,37.25c-4.24,0-7.69,3.45-7.69,7.69s3.45,7.69,7.69,7.69,7.69-3.45,7.69-7.69-3.45-7.69-7.69-7.69ZM82.57,48.5c-1.97,0-3.57-1.6-3.57-3.56s1.6-3.57,3.57-3.57,3.56,1.6,3.56,3.57-1.6,3.56-3.56,3.56Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M82.57,54.13c-7.35,0-13.32,5.97-13.32,13.32v2.06h26.82v-2.06c0-7.35-6.05-13.32-13.5-13.32ZM73.55,65.38l.35-1c1.3-3.66,4.78-6.12,8.67-6.12s7.45,2.45,8.82,6.11l.38,1.01h-18.22Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M15.04,37.25c-4.24,0-7.69,3.45-7.69,7.69s3.45,7.69,7.69,7.69,7.69-3.45,7.69-7.69-3.45-7.69-7.69-7.69ZM15.04,48.5c-1.96,0-3.56-1.6-3.56-3.56s1.6-3.57,3.56-3.57,3.56,1.6,3.56,3.57-1.59,3.56-3.56,3.56Z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M15.04,54.13c-7.45,0-13.51,5.97-13.51,13.32v2.06h26.83v-2.06c0-7.35-5.98-13.32-13.32-13.32ZM5.84,65.38l.38-1.01c1.37-3.66,4.92-6.11,8.82-6.11s7.37,2.46,8.67,6.12l.35,1H5.84Z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M48.8,65.38c-4.24,0-7.69,3.45-7.69,7.7s3.45,7.69,7.69,7.69,7.7-3.45,7.7-7.69-3.46-7.7-7.7-7.7ZM48.8,76.64c-1.96,0-3.56-1.6-3.56-3.56s1.6-3.57,3.56-3.57,3.57,1.6,3.57,3.57-1.6,3.56-3.57,3.56Z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M48.8,82.45c-7.34,0-13.31,5.98-13.31,13.32v2.07h26.63v-2.07c0-7.34-5.97-13.32-13.32-13.32ZM39.78,93.71l.36-1c1.3-3.67,4.78-6.13,8.66-6.13s7.37,2.46,8.67,6.13l.36,1h-18.05Z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M28.36,14.55v4.13h-2.07c-4.98,0-9.19,4.29-9.19,9.38v2.06h-4.12v-2.06c0-7.45,5.97-13.51,13.31-13.51h2.07Z"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M84.63,28.06v2.06h-4.13v-2.06c0-5.09-4.2-9.38-9.19-9.38h-2.06v-4.13h2.06c7.35,0,13.32,6.06,13.32,13.51Z"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M28.36,88.08v4.13h-2.07c-7.34,0-13.31-6.06-13.31-13.51v-2.06h4.12v2.06c0,5.09,4.21,9.38,9.19,9.38h2.07Z"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M84.63,76.64v2.06c0,7.45-5.97,13.51-13.32,13.51h-2.06v-4.13h2.06c4.99,0,9.19-4.29,9.19-9.38v-2.06h4.13Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAllAffiliate);
export default __webpack_public_path__ + "static/media/all-affiliate.d3a33d7f880f8c08a62330b177b83f12.svg";
export { ForwardRef as ReactComponent };